import flagsmith from '@flagsmith/flagsmith';

/**
 * Drops the Flagsmith identity and reloads the anonymous flag set.
 *
 * `flagsmith.logout()` starts a network request for the anonymous flags. Every sign-out path calls
 * it immediately before `redirectToLogin()`, which performs a full document navigation. The
 * browser cancels the in-flight request as soon as that navigation starts, so this request is
 * abandoned by construction — an offline or suspended machine only widens the window.
 *
 * The Flagsmith browser build routes requests through its bundled `unfetch` shim, which assigns
 * the promise `reject` straight to `xhr.onerror`. The cancelled request therefore rejects with a
 * raw `ProgressEvent` carrying no message and no stack. Left unattached, it surfaces through
 * `window.onunhandledrejection` and is reported as an unreportable error (Sentry TEAS-FE-7VE).
 *
 * The failure is not actionable: the caller is already leaving the authenticated application and
 * the login page runs `flagsmith.init` again. Settle the promise and move on.
 */
export const resetFeatureFlags = () =>
  flagsmith
    .logout()
    .catch((error: unknown) =>
      console.warn('Failed to reload anonymous feature flags during sign-out', error)
    );
